import { useCallback, useEffect } from "react";
import { card_visitActions } from "../actions";
import { cardVisitConstants } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import { content } from "../reducers/content.reducer";

export const useCardVisitCreateHook = ({}) => {
    const dispatch = useDispatch();

    const createVisit = useCallback((workspace_id, content_group_id) => {
        const onSuccess = (response) => {
            const { data:visit } = response.data;

            dispatch({ type: cardVisitConstants.CREATE_CARD_VISITS, payload: visit })
        }

        const params = {
            content_group_id
        }

        dispatch(card_visitActions.createCardVisit({workspace_id, params, onSuccess}));
    }, [])

    return {
        createVisit
    }
};